// @flow
import { useState, useEffect } from 'react';
import get from 'lodash/get';
import Spinner from '@tablekit/spinner';
import styled from '@emotion/styled';
import templateRequest from 'utils/templateRequest';

type PropsType = {
  blok: {
    api_path: string,
    fallback: string,
    template: string
  }
};

const Paragraph = styled.p`
  white-space: pre-wrap;
`;

const TemplateParagraph = ({
  blok: { api_path: apiPath, fallback, template }
}: PropsType) => {
  const [isLoading, setIsLoading] = useState(true);
  const [content, setContent] = useState(fallback);

  useEffect(() => {
    templateRequest(apiPath)
      .then(({ data }) => {
        const dynamicContent = template.replace(
          /{{([.a-zA-Z0-9-_]+)}}/gi,
          (match, keyPath) => get(data, keyPath)
        );
        setContent(dynamicContent);
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  }, []);

  return <Paragraph>{isLoading ? <Spinner /> : content}</Paragraph>;
};

export default TemplateParagraph;
